import { Component, OnInit } from '@angular/core';
import {User} from '../../../kf-data-entry/models/user.interface';
import {Page} from '../../../shared/models/page.interface';
import {UsersSearch} from '../../models/users-search.interface';
import {PageRequest} from '../../../shared/models/page-request.interface';
import {MessageService} from '../../../shared/services/message.service';
import {Router} from '@angular/router';
import {UsersService} from '../../services/users.service';
import {WeeeSystemService} from '../../services/weee-system.service';
import {WeeeSystems} from '../../models/weee_systems.interface';
import {Role} from '../../models/role.interface';
import {Observable} from 'rxjs';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {

  message = this.router.getCurrentNavigation()?.extras?.state?.message;
  users!: Page<User>;
  roles!: Role[];
  weeeSystems!: WeeeSystems[];
  private search!: UsersSearch;
  private page: PageRequest = {page: 0, size: 100, sort: 'name', direction: 'asc'};

  constructor(private messageService: MessageService,
              private readonly router: Router,
              private usersService: UsersService,
              private readonly weeeSystemService: WeeeSystemService) { }

  ngOnInit(): void {
    this.usersService.getAll({status: 2}, this.page).subscribe(
      data => this.users = data
    );
    this.usersService.getRoles().subscribe(
      data => this.roles = data
    );
    this.weeeSystemService.getAll({status: 2}, {page: 0, size: 1000, sort: 'description', direction: 'asc'}).subscribe(
      data => this.weeeSystems = data.content
    );
    if (this.message) {
      this.messageService.showMessage(this.message, 'success');
      this.message = undefined;
    }
  }

  loadUsers(event: PageRequest): void {
    this.page = event;
    if (this.search) {
      this.usersService.getAll(this.search, event).subscribe(
        data => this.users = data
      );
    }
    else {
      this.usersService.getAll({status: 2}, event).subscribe(
        data => this.users = data
      );
    }
  }

  searchUsers(search: UsersSearch): void {
    this.search = search;
    if (Object.keys(search).length === 0) {
      this.page = {page: 0, size: 100, sort: 'name', direction: 'asc'};
    }
    this.usersService.getAll(search, this.page).subscribe(
      data => this.users = data
    );
  }

  updateUserStatus(id: number): void {
    this.usersService.updateUser(id).subscribe(
      () => this.updateData()
    );

  }

  deleteUser(id: number): void {
    this.usersService.deleteUser(id).subscribe(
      () => this.updateData()
    );
  }

  printUsers(): void {
    // this.search = search;
    this.usersService.printUsers(this.search).subscribe(
      response => {
        const blob = new Blob([response.body], {type: 'application/pdf'});
        const url = window.URL.createObjectURL(blob);
        window.open(url);
      });
  }

  private updateData(): void {
    if (this.search) {
      this.usersService.getAll(this.search, this.page).subscribe(
        data => this.users = data
      );
    }
    else {
      this.usersService.getAll({status: 2}, this.page).subscribe(
        data => this.users = data
      );
    }
  }

}
